// src/theme/brand-themes.js
//
// Registry of brand themes (spec 20260930-caro-editorial-theme, T027, plan §7.3.1).
// A brand theme is a full plugin (palette, shadows, gradients, optionally typography, shape and
// components). Everything else a user can pick is a colour preset (theme-color-presets.js) that
// only swaps the primary colour. An unknown name falls back to plum EXPLICITLY in create-theme.js,
// never through applyPreset's silent `presets[0]` fallback (F-1, IR-5).
import { plumTheme } from './plugins/plum-theme';
import { goldTheme } from './plugins/gold-theme';
import { buildEditorialTheme } from './plugins/caro-editorial-theme';

export const BRAND_THEMES = {
  plum: () => plumTheme,
  gold: () => goldTheme,
  editorial: (mode, opts) => buildEditorialTheme(mode, opts),
};

export const isBrandTheme = (name) =>
  typeof name === 'string' && Object.prototype.hasOwnProperty.call(BRAND_THEMES, name);

/**
 * Display metadata per brand theme, in card order for ThemeSwitcher (T040). `labelKey` /
 * `descriptionKey` are i18n keys; the name "Caro Editorial" itself is not translated (LD-13).
 * `preview` holds the swatch colours of the card — they depict the theme, so they are literals.
 * `locksTypography`: the theme brings its own fonts; the typography picker is disabled (LD-5).
 */
export const BRAND_THEME_META = {
  plum: {
    labelKey: 'ThemeSwitcher.plum',
    fallbackLabel: 'Plum',
    captionKey: 'ThemeSwitcher.9a3f69',
    fallbackCaption: '#9A3F69',
    locksTypography: false,
    preview: { background: 'linear-gradient(135deg, #9A3F69 0%, #B15483 100%)', check: '#FFFFFF', accent: '#9A3F69' },
  },
  gold: {
    labelKey: 'ThemeSwitcher.gold',
    fallbackLabel: 'Gold',
    captionKey: 'ThemeSwitcher.daa03d',
    fallbackCaption: '#DAA03D',
    locksTypography: false,
    preview: { background: 'linear-gradient(135deg, #DAA03D 0%, #E5BA6D 100%)', check: '#000000', accent: '#DAA03D' },
  },
  editorial: {
    labelKey: 'ThemeSwitcher.editorial',
    fallbackLabel: 'Caro Editorial',
    descriptionKey: 'ThemeSwitcher.editorialDescription',
    fallbackDescription: 'Plum and gold on warm cream, with serif headings',
    locksTypography: true,
    preview: { editorial: true, check: '#3E1729', accent: '#9A3F69' },
  },
};

/** True when `name` is a brand theme that fixes its own fonts (Caro Editorial, LD-5). */
export const themeLocksTypography = (name) => Boolean(BRAND_THEME_META[name]?.locksTypography);

export default BRAND_THEMES;
